import { FieldArrayRenderProps } from "formik";
import { AiAgentKnowledgeDocumentDto } from "src/types/knowledgeDocument";

export const addKnowledgeDocument = (arrayHelpers: FieldArrayRenderProps) => {
    const newDocument: AiAgentKnowledgeDocumentDto = {
        knowledgeDocumentId: "",
        knowledgeDocumentName: "",
        description: null,
        rowId: `${Math.random()}`,
    };
    arrayHelpers.push(newDocument);
};

export const setRowIdForKnowledgeDocuments = (documents: AiAgentKnowledgeDocumentDto[]) => {
    documents.forEach((doc) => {
        if (!doc.rowId) {
            doc.rowId = doc.id || `${Math.random()}`;
        }
    });
};
